// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rzzgA","field":"styles_field__2TBPM","fieldCol":"styles_fieldCol__3mgaa","diffCol":"styles_diffCol__splBi","diff":"styles_diff__3zdVa"};